import { safeFileName } from '../../../utils/fileName'

/**
 * Téléchargement de l'image d'un graphe Chart.js.
 *
 * `toBase64Image()` est la seule façon d'obtenir l'image d'un canvas, et un
 * fichier ne se fabrique pas en YAML : c'est la pièce impérative de l'export.
 * Le lien est créé à la volée — rien n'est envoyé au serveur.
 *
 * Fichier `.js` séparé : un `.jsx` qui exporte autre chose qu'un composant
 * casse le Fast Refresh de Vite.
 *
 * @param {object|null} chart  L'instance Chart.js (ref de react-chartjs-2).
 * @param {string} name        Nom du fichier, sans extension.
 * @returns {boolean} true si un téléchargement a été déclenché.
 */
export function downloadChartImage(chart, name = 'graphique') {
  if (!chart || typeof chart.toBase64Image !== 'function') return false
  const link = document.createElement('a')
  link.href = chart.toBase64Image('image/png', 1)
  link.download = `${safeFileName(name, 'graphique')}.png`
  link.click()
  return true
}
